export default "__VITE_ASSET__CLS211Z1__"